import { Link } from "react-router-dom";
import Robot from "../../Images/error404.png";
const PageNotFound = () => {
  return (
    <>
      <main class="relative grid min-h-screen place-items-center bg-gradient-to-br from-indigo-100 via-white to-indigo-200 px-6 py-24 sm:py-32 lg:px-8 overflow-hidden">
        <div class="absolute inset-0 -z-10 overflow-hidden">
          <div class="absolute left-[10%] top-[20%] h-72 w-72 rounded-full bg-indigo-300 opacity-20 blur-3xl animate-pulse"></div>
          <div class="absolute right-[15%] bottom-[15%] h-64 w-64 rounded-full bg-purple-400 opacity-20 blur-2xl animate-ping"></div>
          <div class="absolute left-[50%] top-[50%] h-48 w-48 rounded-full bg-pink-300 opacity-10 blur-2xl animate-pulse"></div>
        </div>

        <div class="text-center animate-fade-in-down duration-700 ease-out">
          <img
            src={Robot}
            alt="Robot"
            class="mx-auto mb-6 w-40 h-40 object-contain rounded-full shadow-lg animate-float"
          />
          <p class="text-base font-semibold text-indigo-600">404</p>
          <h1 class="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl">
            Page Not Found
          </h1>
          <p class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">
            Sorry, we couldn't find the page you're looking for.
          </p>
          <div class="mt-10 flex items-center justify-center gap-x-6">
            {window.localStorage.getItem("isAuthenticated") === "true" ? (
              <Link
                to="/main"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
              >
                Go back Main Page
              </Link>
            ) : (
              <Link
                to="/login"
                class="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 transition-all duration-300"
              >
                Go back to Login Page
              </Link>
            )}
          </div>
        </div>
      </main>
    </>
  );
};

export default PageNotFound;
